/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * bdk/v2/services/library.proto
 * OpenAPI spec version: version not set
 */

export type Bdkv2CredentialType =
  (typeof Bdkv2CredentialType)[keyof typeof Bdkv2CredentialType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Bdkv2CredentialType = {
  CredentialTypeText: 'CredentialTypeText',
  CredentialTypeSensitiveText: 'CredentialTypeSensitiveText',
  CredentialTypeSensitiveDictionary: 'CredentialTypeSensitiveDictionary',
} as const;
